export default __webpack_public_path__ + "static/media/borda-esquerda-verso.fd55f10f.png";